import React from "react";
import {
  InputText,
  Label,
  Calendar,
  Dropdown,
} from "../../../../components/Inputs";
import { toDBDate, toUIInputDate } from "../../../../components/Utils";

const IssuerOptions = [
  { value: "dibkom-Zertifikat", label: "dibkom-Zertifikat" },
  { value: "Vodafone Kabel Deutschland", label: "Vodafone Kabel Deutschland" },
];
const CertificateOptionMap = {
  "dibkom-Zertifikat": [
    { label: "dibkom - Anschlussnetze NE3" },
    { label: "dibkom - Koax-Installation NE4" },
    { label: "dibkom - LWL in Kabelnetzen NE3/NE4" },
    { label: "dibkom - LWL-Installation" },
    // { label: 'VKD - Azubi in Berufsausbildung' },
    // { label: 'VKD - BK - Projekt' },
    // { label: 'VKD - BK - Projekt IPO' },
    // { label: 'VKD - FN - VF Festnetz Enterprise Advanced' },
    // { label: 'VKD - FN - VF Festnetz Enterprise Basic' },
    // { label: 'VKD - KN1 - Einrichtung HSI in rückkanalfähigen NE4' },
    // { label: 'VKD - KN2 - Inst.-Entstörung NE4' },
    // { label: 'VKD - KN3 - Bau-Entstörung NE3' },
    // { label: 'VKD - KNTB - Montage-Messung am erdverlegten Kabel' },
  ],
  "Vodafone Kabel Deutschland": [
    // { label: 'dibkom - Anschlussnetze NE3' },
    // { label: 'dibkom - Koax-Installation NE4' },
    // { label: 'dibkom - LWL in Kabelnetzen NE3/NE4' },
    // { label: 'dibkom - LWL-Installation' },
    { label: "VKD - Azubi in Berufsausbildung" },
    { label: "VKD - BK - Projekt" },
    { label: "VKD - BK - Projekt IPO" },
    { label: "VKD - FN - VF Festnetz Enterprise Advanced" },
    { label: "VKD - FN - VF Festnetz Enterprise Basic" },
    { label: "VKD - KN1 - Einrichtung HSI in rückkanalfähigen NE4" },
    { label: "VKD - KN2 - Inst.-Entstörung NE4" },
    { label: "VKD - KN3 - Bau-Entstörung NE3" },
    { label: "VKD - KNTB - Montage-Messung am erdverlegten Kabel" },
  ],
};
const TypeOptions = [
  { label: "Anmeldung zum Zertifikat", value: "INTENTION" },
  { label: "Bestehendes Zertifikat", value: "CERTIFICATE" },
];

const IssuerIDs = [
  { value: 1, label: "dibkom-Zertifikat" },
  { value: 2, label: "Vodafone Kabel Deutschland" },
];
const CertificateIDs = [
  { label: "dibkom - Anschlussnetze NE3", value: 1 },
  { label: "dibkom - Koax-Installation NE4", value: 2 },
  { label: "dibkom - LWL in Kabelnetzen NE3/NE4", value: 8 },
  { label: "dibkom - LWL-Installation", value: 3 },
  { label: "VKD - Azubi in Berufsausbildung", value: 15 },
  { label: "VKD - BK - Projekt", value: 12 },
  { label: "VKD - BK - Projekt IPO", value: 14 },
  { label: "VKD - FN - VF Festnetz Enterprise Advanced", value: 9 },
  { label: "VKD - FN - VF Festnetz Enterprise Basic", value: 10 },
  { label: "VKD - KN1 - Einrichtung HSI in rückkanalfähigen NE4", value: 11 },
  { label: "VKD - KN2 - Inst.-Entstörung NE4", value: 4 },
  { label: "VKD - KN3 - Bau-Entstörung NE3", value: 7 },
  { label: "VKD - KNTB - Montage-Messung am erdverlegten Kabel", value: 13 },
];

const CertificateForm = React.forwardRef(function CertificateForm(
  {
    className = "",
    model = {
      issuer: "",
      name: "",
      number: "",
      type: "",
      intension_date: "",
      status: "",
    },
  },
  ref,
) {
  const [state, setState] = React.useState({
    issuer: model.issuer || "",
    name: model.name || "",
    intension_date: toUIInputDate(model.intension_date),
    number: model.number || "",
    type: model.type || "",
    error: {
      issuer: null,
      name: null,
      intension_date: null,
      type: null,
    },
  });

  const validate = () => {
    const { error, ...others } = state;
    let modelData = { ...others };
    // check if all values are set
    const newError = { ...error };
    let isValid = true;
    Object.keys(modelData).forEach((key) => {
      if (newError[key] && modelData[key] === "") {
        newError[key] = true;
        isValid = false;
      }
    });
    // registration date
    modelData.intension_date = toDBDate(modelData.intension_date);
    if (!isValid) {
      setState((prev) => ({ ...prev, error: newError }));
      return null;
    }
    const { id, index } = model;
    const issuer = IssuerIDs.find((item) => item.label === modelData.issuer);
    if (issuer) {
      modelData.issuer_id = issuer.value;
    }
    const cert = CertificateIDs.find((item) => item.label === modelData.name);
    if (cert) {
      modelData.certificate_id = issuer.value;
    }
    return { id, index, ...modelData };
  };

  React.useImperativeHandle(ref, () => ({
    getModel: () => validate(),
  }));

  const changeIssuer = (event) => {
    const value = event.value;
    setState((prev) => ({
      ...prev,
      issuer: value,
      ...(value !== prev.issuer ? { name: "" } : null),
    }));
  };

  const { issuer, name, number, intension_date, type, error } = state;
  const CertificateOptions = (CertificateOptionMap[issuer] || []).map(
    (item) => ({
      label: item.label,
      value: item.value || item.label,
    }),
  );
  return (
    <div className={className}>
      <div className="neg-margin-lr">
        <div className="w3-row pad-top">
          <div className="w3-col s6 pad-lr">
            <div className={`${error.issuer ? "error-group" : ""}`}>
              <Label htmlFor="issuer">{`Quelle*`}</Label>
              <Dropdown
                id="issuer"
                className="w3-block w3-border"
                value={issuer}
                placeholder="Bitte auswählen"
                options={IssuerOptions}
                onChange={changeIssuer}
                showClear
              />
            </div>
            <div className={`pad-top ${error.name ? "error-group" : ""}`}>
              <Label htmlFor="name">{`Typ*`}</Label>
              <Dropdown
                id="name"
                className="w3-block w3-border"
                value={name}
                placeholder="Bitte auswählen"
                options={CertificateOptions}
                onChange={(event) => {
                  const value = event.value;
                  setState((prev) => ({ ...prev, name: value }));
                }}
                showClear
              />
            </div>
            <div className={`pad-top ${error.type ? "error-group" : ""}`}>
              <Label htmlFor="type">{`Anmeldung/bestehendes Zerzifikat*`}</Label>
              <Dropdown
                type="type"
                className="w3-block w3-border certificateRegister"
                value={type}
                placeholder="Bitte auswählen"
                options={TypeOptions}
                onChange={(event) => {
                  const value = event.value;
                  setState((prev) => ({ ...prev, type: value }));
                }}
                showClear
              />
            </div>
          </div>
          <div className="w3-col s6 pad-lr">
            <div className={`${error.intension_date ? "error-group" : ""}`}>
              <Label htmlFor="intension_date">{`angemeldet für den*`}</Label>
              <Calendar
                id="intension_date"
                className="w3-block w3-border"
                readOnlyInput={true}
                dateFormat="dd.mm.yy"
                value={intension_date}
                onChange={(event) => {
                  const value = event.value;
                  setState((prev) => ({ ...prev, intension_date: value }));
                }}
              />
            </div>
            <div className="pad-top">
              <Label htmlFor="number">{`Nummer/Kurzbemerkung`}</Label>
              <InputText
                id="number"
                className="w3-block w3-border"
                value={number}
                onChange={(event) => {
                  const value = event.target.value;
                  setState((prev) => ({ ...prev, number: value }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default CertificateForm;
